import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { HomeClientPage } from "@/components/providers/home-page";
import { getTodayEpisodes } from "@/lib/episodes";
import { fetchNavPages, fetchSiteSettings } from "@/lib/page-data";
import { getStreamMetadata } from "@/lib/stream";

const routeApi = getRouteApi("/");

const HomePage = () => {
  const { pages, settings } = routeApi.useLoaderData();

  return (
    <HomeClientPage
      settings={settings}
      pages={pages}
      episodes={routeApi.useLoaderData().episodes}
      initialMetadata={routeApi.useLoaderData().initialMetadata}
      getMetadata={getStreamMetadata}
    />
  );
};

export const Route = createFileRoute("/")({
  component: HomePage,
  loader: async () => {
    const [pages, settings, episodes, metadata] = await Promise.all([
      fetchNavPages(),
      fetchSiteSettings(),
      getTodayEpisodes().catch(() => []),
      getStreamMetadata().catch(() => []),
    ]);
    return {
      episodes,
      initialMetadata: metadata.length === 0 ? null : (metadata[0] ?? null),
      pages,
      settings,
    };
  },
});
